export const FILTER_NAME = 'sales_margin'
